import * as React from "react";
import { Skeleton } from "@/components/ui";

export const SkeletonList: React.FC = () => {
  return (
    <div className="space-y-1">
      {[...Array(5)].map((_, i) => (
        <div key={`skeleton-${i}`} className="flex items-center gap-3 px-4 py-3 rounded-lg">
          <Skeleton className="h-9 w-9 rounded-full shrink-0" />
          <div className="flex-1 space-y-2 min-w-0">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-48" />
          </div>
        </div>
      ))}
    </div>
  );
};
